import React, { ReactElement } from 'react';

import Head from 'next/head';
import { useRouter } from 'next/router';
import log from 'loglevel';
import { MainLayout } from '../layouts';

export default function NotFoundPage (): ReactElement {
  const router = useRouter();
  log.error('Page not found', router.asPath);

  return (
    <MainLayout>
      <Head>
        <title>CampusLush | Not Found</title>
      </Head>
      <h1>404 - Page Not Found</h1>
    </MainLayout>
  );
}
